/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 15 2024
 **/

import { useFileBoxContext } from "../../../../../hooks";
import Share3DButton from "./Share3DButton";
import UploadAudioZoneButton from "./UploadAudioZoneButton";

export interface UploadToSpaceButtonProps {
	file: Required<FileBox.Folders.GetFolderFileListResponse>["content"][number];
	size: "XXlarge" | "Xlarge";
	fill?: keyof Colors;
}

export default function UploadToSpaceButton(props: UploadToSpaceButtonProps) {
	const fileBoxContext = useFileBoxContext();

	if (!fileBoxContext) return;

	if (fileBoxContext === "3DShare") {
		return <Share3DButton {...props} />;
	}

	return <UploadAudioZoneButton {...props} />;
}
